<div class="content {{ secondClass }}" *ngIf="group">
  <div class="header modal-header" *ngIf="isShowModal && !noClose" [ssg-draggable]="false">
    <i (click)="onCancelChange()" class="icon-close-o"></i>
    <span class="caption">{{ headerLabel }}</span>
  </div>
  <div class="frm-box">
    <form [formGroup]="group" class="frm-main" [class.mainform-isnotmodal]="!isShowModal">
      <div class="main" *ngIf="group" [class.main-isnotmodal]="!isShowModal">
        <form-control-model
          *ngIf="columns && columns?.length > 0"
          [columns]="columns"
          [group]="group"
          [model]="model"
          [isShowModal]="isShowModal"
          [defaultHeight]="defaultHeight"
          (valueChange)="valueChange.emit($event)"
          (valueChangeWithName)="valueChangeWithName.emit($event)"
          (CompleteData)="CompleteData.emit($event)"
          (valueChangeByApiName)="valueChangeByApiName.emit($event)"
          [hasDefault]="hasDefault"
          [hasfocus]="hasfocus"
          [filterLookUp]="filterLookUp"
          [hasCheckBoxLookUpTree]="hasCheckBoxLookUpTree"
          (onRowsSelected)="onRowsSelected.emit($event)"
          (onRowSelected)="onRowSelected.emit($event)">
          <ng-container class="fc-Content">
            <ng-content select=".fcContent"></ng-content>
          </ng-container>
          <ng-container class="fct-Content">
            <ng-content select=".fctContent"></ng-content>
          </ng-container>
        </form-control-model>
        <ng-content select=".content"></ng-content>
      </div>
      <div class="footer">
        <ng-content select=".footer"></ng-content>

        <div class="modal-action">
          <div *ngIf="erroremessage" class="alert alert-danger">
            <div [hidden]="!erroremessage">
              {{ erroremessage }}
            </div>
          </div>
          <ssg-button
            *ngIf="managePermission && !noSubmit"
            buttontype="submit"
            (click)="onsubmitChange(group)"
            [disabled]="submitButtonDisabled || erroremessage !== undefined || (isSubmitted && !isValid(group))"
            icon="icon-floppy-o1"
            label="{{
              isSaved ? (savingLabel ? savingLabel : ('General.Saving' | translate)) : saveLabel ? saveLabel : ('General.Save' | translate)
            }}"
            appearance="flat"
            class="btn-ok">
          </ssg-button>
          <ssg-button
            *ngIf="(!managePermission || (noSubmit && !noClose)) && showCloseBtn"
            (click)="onCancelChange()"
            buttontype="button"
            label="{{ 'General.Close' | translate }}"
            [disabled]="isSaved"
            icon="icon-cancel-circle"
            appearance="flat"
            class="btn-close">
          </ssg-button>
          <ssg-button
            *ngIf="managePermission && !noSubmit && !noClose"
            buttontype="button"
            (click)="onCancelChange()"
            icon="icon-cancel-circle"
            [disabled]="isSaved"
            label="{{ 'General.Cancel' | translate }}"
            appearance="flat"
            class="btn-close">
          </ssg-button>
        </div>
      </div>
    </form>
  </div>
</div>
